import React, { useState } from 'react';
import {
  VideoOrderEnum,
  RegionCodeEnum,
  VideoTypeEnum,
  MaxResultsEnum,
  SearchSettingsEnum,
} from '../../types/types';
import { useAppSelector, useAppDispatch } from '../../store/store';
import { updateSearchBar } from '../../store/apiPageReducer';
import './_customSelect.scss';

type OptionsType =
  | typeof VideoOrderEnum
  | typeof RegionCodeEnum
  | typeof VideoTypeEnum
  | typeof MaxResultsEnum;

type CustomSelectProps = {
  options: OptionsType;
  name: SearchSettingsEnum;
};

export default function CustomSelect(props: CustomSelectProps) {
  const { options, name } = props;
  const [isOpen, setIsOpen] = useState(false);
  const state = useAppSelector((state) => state.apiPage);
  const dispatch = useAppDispatch();
  const { searchBarState, search } = state;

  const isDisabled =
    (name === SearchSettingsEnum.videoOrder || name === SearchSettingsEnum.videoType) &&
    search === '';
  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value: string) => () => {
    if (searchBarState[name] === value) return;
    dispatch(updateSearchBar({ [name]: value }));
    setIsOpen(false);
  };

  return (
    <div className="dropdown__wrapper">
      <div className={`dropdown__header ${isDisabled ? 'disable' : ''}`} onClick={toggling}>
        {searchBarState[name]}
      </div>
      {isOpen && !isDisabled && (
        <ul className="dropdown__list">
          {Object.values(options).map((option, i) => (
            <li
              className={`dropdown__list-item ${searchBarState[name] === option ? 'active' : ''}`}
              onClick={onOptionClicked(option)}
              key={i}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
